/**
 * Helper function for checking whether the current mode is dev,
 * can be used to swap in mocks automatically.
 *
 * @returns {boolean} Whether we are currently in dev mode
 */
export const isDevMode = () => process.env.NODE_ENV === "development";

/**
 * Utility function for adding a timeout to mock API calls
 *
 * @param {number} delay Desired delay, in ms
 * @returns {Promise<void>} A promise that can be awaited
 */
export const timeout = (delay) => new Promise((res) => setTimeout(res, delay));

export const validateForm = (formData) => {
  const errors = [];

  if (!formData.filmTitle || formData.filmTitle.trim() === "") {
    errors.push("Film title is required.");
  }

  if (!formData.directors || formData.directors.length === 0) {
    errors.push("At least one director is required.");
  }

  if (!formData.borough || formData.borough === "") {
    errors.push("Borough is required.");
  }

  if (!formData.present || formData.present === "") {
    errors.push("Please indicate whether the director will be present.");
  }

  if (!formData.videoLink || formData.videoLink.trim() === "") {
    errors.push("Video link is required.");
  }

  const directorsSet = new Set(formData.directors);
  const epOverlap = formData.executiveProducers.filter(ep => directorsSet.has(ep));
  if (epOverlap.length > 0) {
    errors.push(`The following people cannot be both a director and executive producer: ${epOverlap.join(", ")} (Executive Producers are people other than the director that lent any gear or a location to the production.)`);
  }

  return errors;
};